export default "__VITE_ASSET__EILuFr_M__"